import api from "../http-request";
// import apiConstants from "../apiConstant";

// [GET METHOD]

export const getDetailCategoryApi = async (id) =>
  api.get(`api/category-spaces/detail/${id}`);